// hooks/useViewDocumentModal.js
import { create } from "zustand";

const useViewYTVideo = create((set) => ({
  isOpen: false,
  url: null,
  label: null,
  open: (url, label) => set({ isOpen: true, url, label }),
  close: () => set({ isOpen: false, url: null, label: null }),
}));

export default useViewYTVideo;
